import Api from '@/services/Api'

export default {
  login (username, password) {
    return Api().post('/bruker/login.json', {
      Brukernavn: username,
      PassordHash: '' + password,
      hash2FA: localStorage.getItem('avanti-hash2FA') || ''
    })
  },

  verify (data) {
    return Api().post('/bruker/verify.json', data)
  },

  logout () {
    return new Promise((resolve, reject) => {
      resolve()
    })
  },

  profile () {
    return Api().get('/bruker/profile.json')
  },

  refresh () {
    return Api().get('/bruker/renew-token.json')
  },

  changePassword (data) {
    return Api().put('/bruker/change-password.json', data)
  },

  forgotPassword (data) {
    return Api().post('/bruker/forgot-password.json', data)
  },

  resetPassword (token, data) {
    return Api().post('/bruker/reset-password/' + token + '.json', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js